import { getEmptyProduct } from '@/utils/emptyProduct';

import { defineStore } from 'pinia';
import { computed, ref, toRaw } from 'vue';

import type { IProduct } from '@/typescript/interfaces/IProduct';
import type { IField } from '@/typescript/interfaces/IField';
import type { ITextField } from '@/typescript/interfaces/ITextField';
import type { IImageField } from '@/typescript/interfaces/IImageField';

const useProductStore = defineStore('product', () => {
    const selectedProduct = ref<IProduct>(getEmptyProduct());
    const productList = ref<IProduct[]>([getEmptyProduct()]);

    const selectedProductConfiguration = computed(() => selectedProduct.value.configuration);
    const selectedFieldId = ref<string>();

    function updateField(field: IField) {
        const labelIndex = selectedProductConfiguration.value.fields.findIndex((currentField) => currentField.id === field.id);
        if (labelIndex >= -1) {
            selectedProductConfiguration.value.fields[labelIndex] = field;
        }
    }

    function addField(field: IField) {
        selectedProductConfiguration.value.fields.push(field);
    }

    function removeField(field: IField) {
        const labelIndex = selectedProductConfiguration.value.fields.findIndex((currentField) => currentField.id === field.id);
        if (labelIndex >= -1) {
            selectedProductConfiguration.value.fields.splice(labelIndex, 1);
        }
    }

    function getFieldById(id: string): IImageField | ITextField | undefined {
        return selectedProductConfiguration.value.fields.find((field) => field.id === id) as IImageField | ITextField | undefined;
    }

    function getFilledFields(): IField[] {
        const fields = toRaw(selectedProductConfiguration.value.fields);
        return fields.filter((field) => {
            if ((field as ITextField).defaultText) {
                return (field as ITextField).text !== undefined;
            }
            return (field as IImageField).url !== undefined;
        });
    }

    return {
        selectedProductConfiguration,
        productList,
        selectedProduct,
        selectedFieldId,
        updateField,
        addField,
        removeField,
        getFieldById,
        getFilledFields,
    };
});

export default useProductStore;
